import React, { useEffect, useState } from "react";
import { client, urlFor } from "../../client";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { motion } from "framer-motion";

import "./Testimonial.scss";
import AppWrap from "../../wrapper/AppWrap/AppWrap";

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [brands, setBrands] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const queryT = '*[_type=="testimonials"]';
    const queryB = '*[_type=="brands"]';

    client.fetch(queryT).then((res) => setTestimonials(res));

    client.fetch(queryB).then((res) => setBrands(res));
  }, []);
  // const currentTestimonail = testimonials[currentIndex];
  const current_testmonial = testimonials[currentIndex];
  return (
    <>
      <div className="app__testimonals">
        {testimonials.length && (
          <div className="app__testimonials-reviews app__flex">
            <img
              src={urlFor(testimonials[currentIndex]?.imgurl).url()}
              alt={testimonials[currentIndex]?.company}
            />
            <div className="review-info">
              <p>{testimonials[currentIndex]?.feedback}</p>
              <div className="person-info bold-text">
                <p className="">{testimonials[currentIndex]?.name}</p>
                <p className="p-text">{testimonials[currentIndex]?.company}</p>
              </div>
            </div>
          </div>
        )}
        <div className="control-testimonial">
          <motion.div
            whileHover={{ scale: [1, 1.2, 1] }}
            className="left app__flex"
            onClick={() =>
              setCurrentIndex(
                currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1
              )
            }
          >
            <HiChevronLeft />
          </motion.div>
          <motion.div
            whileHover={{
              scale: [1, 1.2, 1],
            }}
            className="right app__flex"
            onClick={() =>
              setCurrentIndex(
                currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1
              )
            }
          >
            <HiChevronRight />
          </motion.div>
        </div>
        <div className="app__testimonials-brands"></div>
      </div>
      <div className="app__brands">
        {brands.length &&
          brands.map((brand) => (
            <div key={brand.name} className="brand">
              <img src={urlFor(brand.imgUrl)} alt={brand.name} />
            </div>
          ))}
      </div>
    </>
  );
};

export default AppWrap(Testimonial, 'testimonial');
